import React, { useEffect, useRef, useState } from 'react';
import jsQR from 'jsqr';

const QRScanner = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [qrResult, setQrResult] = useState(null);
  const [isCameraActive, setIsCameraActive] = useState(true);
  const streamRef = useRef(null);

  useEffect(() => {
    if (isCameraActive) {
      startCamera();
      const interval = setInterval(scanQRCode, 500);
      return () => clearInterval(interval);
    }
  }, [isCameraActive]);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error('Chyba při spuštění kamery:', err);
    }
  };

  const stopCamera = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
    }
    setIsCameraActive(false);
  };

  const playBeep = () => {
    const beepSound = new Audio(
      'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEAESsAACJWAAACABAAZGF0YQAAAAA='
    );
    beepSound.play().catch(err => console.error('Nepodařilo se přehrát zvuk:', err));
  };

  const isValidQRCode = (data) => {
    return data && data.startsWith('APP:'); // Uprav dle potřeby
  };

  const scanQRCode = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas || video.readyState !== 4) return;

    const ctx = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const code = jsQR(imageData.data, imageData.width, imageData.height);

    if (code) {
      drawBoundingBox(ctx, code.location);
      if (isValidQRCode(code.data)) {
        playBeep();
        setQrResult(code.data);
        stopCamera();
      }
    }
  };

  const drawBoundingBox = (ctx, location) => {
    if (!location) return;
    ctx.beginPath();
    ctx.moveTo(location.topLeftCorner.x, location.topLeftCorner.y);
    ctx.lineTo(location.topRightCorner.x, location.topRightCorner.y);
    ctx.lineTo(location.bottomRightCorner.x, location.bottomRightCorner.y);
    ctx.lineTo(location.bottomLeftCorner.x, location.bottomLeftCorner.y);
    ctx.closePath();
    ctx.lineWidth = 4;
    ctx.strokeStyle = 'lime';
    ctx.stroke();
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>QR Scanner</h2>
      <video ref={videoRef} autoPlay playsInline style={{ width: '300px' }} />
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      {qrResult ? (
        <div>
          <h3>Načtený QR kód:</h3>
          <p>{qrResult}</p>
          <button onClick={() => {
            setQrResult(null);
            setIsCameraActive(true);
          }}>Skenovat znovu</button>
        </div>
      ) : (
        <p>Hledejte QR kód…</p>
      )}
    </div>
  );
};

export default QRScanner;